/** Shared transaction lifecycle for authenticated browser writes and SDK adapters. */
export interface AppwriteTransactionLifecycle {
    createTransaction(params: { ttl: number }): Promise<{ $id: string }>;
    updateTransaction(params: { transactionId: string; commit?: boolean; rollback?: boolean }): Promise<unknown>;
}

export async function runAppwriteTransaction<T>(
    tables: AppwriteTransactionLifecycle,
    stage: (transactionId: string) => Promise<T>,
    ttl = 60,
    warn: (message: string) => void = message => console.warn(message),
): Promise<T> {
    const transaction = await tables.createTransaction({ ttl });
    try {
        const result = await stage(transaction.$id);
        await tables.updateTransaction({ transactionId: transaction.$id, commit: true });
        return result;
    } catch (error) {
        try { await tables.updateTransaction({ transactionId: transaction.$id, rollback: true }); }
        catch (rollbackError) { warn(`Appwrite transaction cleanup needs review: ${String(rollbackError)}`); }
        throw error;
    }
}
